import { createTranslations } from '@npco/utils-translations'

export const createSavingsAccountPromptTranslations = createTranslations({
  prompt:
    'Your new Zeller Savings Account is ready to use. Simply activate it by adding your Tax File Number.',
})
